<style scoped lang="scss">
  @import "../../../common/public";

  .cover {
    background-color: $mainColor;
    color: #FFFFFF;
  }
</style>

<template>
  <ul class="filter bg_fff pl15 pr15 pt10 pb10 flex">
    <li v-for="(data,index) in filter" class="fs12 mr10 bg_eee pl10 pr10 pt5 pb5 radius20" @click="handler(index,data)"
        :class="{cover:index===curr}">{{data.name}}
    </li>
  </ul>
</template>

<script>
  const filter = [
    {name: '按内容查看', value: 'content'},
    {name: '按时间查看', value: 'time'},
  ];
  export default {
    name: "doc-comment-filter",
    data() {
      return {
        filter,
        curr: 0
      }
    },
    methods: {
      handler(index, data) {
        this.curr = index;
        this.$emit('change', data.value);
      }
    },
  }
</script>



// WEBPACK FOOTER //
// src/plugins/doc/comment/filter.vue